import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, tap,from, of, zip } from 'rxjs';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { DialogService } from '../../../dialog/services/dialog.service';
import { ReviewResponseDTO } from '../../model/reviewResponseDTO';
import { GroupedReviewRespose } from '../../model/groupedTasks';
import { TaskService } from '../../services/tasks.service';
import { PagedResultTask } from '../../model/pagedResultTask';
import { TaskDetailDialogComponent } from '../../task-detail-dialog/task-detail-dialog.component';

@Component({
  selector: 'app-requested-task-list',
  templateUrl: './requested-task-list.component.html',
  styleUrls: ['./requested-task-list.component.css']
})
export class RequestedTaskListComponent implements OnInit, OnDestroy, AfterViewInit {
  tasks: ReviewResponseDTO[] = [];
  groupedTasks: GroupedReviewRespose[] = [];
  dataSource: ReviewResponseDTO[] = [];
  isListloading = false;  
  displayedColumns: string[] = ['requirementId', 'requirementShortType', 'requestId', 'requirementTitle' , 'approvalStatus'];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  paginationSubscription?: Subscription;
  dialogBoxSubscription?: Subscription;
  isError = false;
  isEmptyList = false;
  errorMessage!: string;
  totalRecords?: number;
  //groupedTasksAsync?: GrouObservable<number, ReviewResponseDTO[]>;

  constructor(public dialog: MatDialog,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly requestService: TaskService,
    private readonly dialogService:DialogService) {
  }
  ngOnDestroy(): void {
    this.paginationSubscription?.unsubscribe();
    this.dialogBoxSubscription?.unsubscribe();
    }

  getTasks() {
    this.isListloading = true;
    this.isError = false;
    this.requestService.getPendingTasks(
      this.paginator?.pageSize ?? 10,
      this.paginator?.pageIndex ?? 0).subscribe({
        next: (response: PagedResultTask) => {
          this.totalRecords = response.totalRecords;
          this.isEmptyList = this.totalRecords == null ? true : false;
          this.groupedTasks = [];
         from(response.records).pipe(
           groupBy(res => res.requestId),
           mergeMap((group) => zip(of(group.key), group.pipe(toArray())))           
          ).subscribe({
            next: (groupedRes) => {              
              this.groupedTasks.push({ key: groupedRes[0], tasks: groupedRes[1] })             
              }
          })          
      },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
        this.isListloading = false; 
      },
      complete: () => { this.isListloading = false; }
    });
  }

  ngOnInit() {
    this.getTasks();
  }

  ngAfterViewInit(): void {
    this.paginationSubscription = this.paginator?.page.pipe(tap(() => this.getTasks())).subscribe();    
  }

  onTaskNaviagte(taskId: number) {
    const taskDialogRef = this.dialog.open(TaskDetailDialogComponent, {
      data: { id: taskId },
      width: '100%',
      height: '100%',
      maxWidth:'100vw',

    });
    this.dialogBoxSubscription = taskDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.router.navigate(['/pendingtasks'], { relativeTo: this.route });
      }
    });
  }

  onrequestnavigate(requestId:number){
    const url = this.router.createUrlTree([`/request/detail/${requestId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }

  onTaskNaviagteNewPage(taskId:number){
    const url = this.router.createUrlTree([`/task/detail/${taskId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }
  getCSSColorStatus(approvalStatus:string):string {
    return this.requestService.getCSSColorforTask(approvalStatus);
  }
}
